/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/share_ios'
export default icon
